import type { FaireProductEntity } from "../../entity_types/product";

export const p_fthsf6ddxr: FaireProductEntity = {
  token: "p_fthsf6ddxr",
  type: "product",
  name: "Let's Stay Trashy Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/baad6dbd52de7d44336fe63db51f804467b7e7a35ed472b25186d2b46dc700e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25ecfbeffc5920857ca3b54d5ed3f4ebf616cde706d5da89551c85fdc80b4cb9.jpeg",
    "https://cdn.faire.com/fastly/aa08d3247f5a4ead2e6e687f2a004af7bdd6b768eed09547c14874c5b6572a25.jpeg",
    "https://cdn.faire.com/fastly/381532c0ce767e78882f1f1f39b0a761393631c2316080e4ed60e8240ced764e.jpeg",
    "https://cdn.faire.com/fastly/9f3a0afbfae30de850a01057528648a91e599df97195165dad15cdf6958f7360.jpeg",
    "https://cdn.faire.com/fastly/1c7ba325b91ec3959ab9f9e28dba86fa7f60ed30c222878ae61b90b7d371bdba.jpeg",
    "https://cdn.faire.com/fastly/3aafcdf2350477e4aaba5c3c641a321512b1bb9c75925a83dc4865d7e1beb44f.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Valentine's Day Collection featuring an all-over design displaying a pattern of raccoons, eaten food, and hearts with a funny love-themed sentiment that reads \"Let's Stay Trashy.\" Raccoon inspired pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating brown and white checker pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Let's Stay Trashy kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun love-themed gift perfect for both friends and partners on Valentine's Day or in everyday moments.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:09.906Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
